import { Form, FormProps } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import patterns from '../../config/patterns';
import { useAuth } from '../../contexts/authentication.context';
import { AppRoutes } from '../../enums';
import { useFormState } from '../../hooks';
import { taApiClient } from '../../utils/http-client';
import { ButtonType, TAButton, TAInput, TAPasswordInput } from '../widgets';
import './antd.form.css';

export const SignInForm: React.FC<FormProps & any> = props => {
	const [form] = Form.useForm();
	const { setAuthenticated } = useAuth();
	const [formInvalidMsg, setFormInvalidMsg] = useState(null);
	const [loading, setLoading] = useState(false);
	const { formState, setFieldState } = useFormState({
		email: '',
		password: ''
	});
	const onFinish = async values => {
		setLoading(true);
		const url = props.signInUrl;

		try {
			const response = await taApiClient.post(url, values);
			setLoading(false);
			const responseOK = response && Math.round(response.status / 100) === 2;
			if (!responseOK) {
				throw new Error(
					response && response.data
						? response.data.message
						: 'Something went wrong. Please contact support for help.'
				);
			}
			setAuthenticated(true, response.data.token, response.data.profile);
			const referer = props.location.state?.referer || props.onLoginSuccessRedirect || '/';
			return props.history.push(referer);
		} catch (e: any) {
			setLoading(false);
			setFormInvalidMsg(e.message);
			return;
		}
	};
	return (
		<Form layout="vertical" onFinish={onFinish} className="ta-form" form={form}>
			{formInvalidMsg ? <p className="ta-form__invalid-msg">{formInvalidMsg}</p> : null}
			<Form.Item
				label="Email"
				hasFeedback
				name="email"
				rules={[
					{ required: true, message: 'Please input your email!' },
					{ type: 'email', message: 'Invalid email address.' }
				]}
			>
				<TAInput onChange={setFieldState('email')} />
			</Form.Item>
			<Form.Item
				label="Password"
				hasFeedback
				name="password"
				rules={[
					{ required: true, message: 'Please enter your Password.' },
					{
						pattern: patterns.passwordPattern,
						message: 'Password must contain at lease one alphabet and one number without spaces'
					}
				]}
			>
				<TAPasswordInput onChange={setFieldState('password')} />
			</Form.Item>
			<Form.Item>
				<TAButton
					htmlType="submit"
					btntype={ButtonType.PRIMARY}
					style={{
						width: '100%',
						padding: '.8rem 0.8rem',
						borderRadius: '.9rem',
						fontSize: '.9rem',
						fontWeight: 500,
						lineHeight: '1.36',
						height: 'auto'
					}}
					loading={loading}
				>
					Sign in
				</TAButton>
			</Form.Item>
			<p>
				Are you new here? <Link to={AppRoutes.SIGNUP}>Sign up</Link>
			</p>
			<p className="d-flex justify-content-between align-items-center">
				<Link to="/forget-password">Forgot password?</Link>
			</p>
		</Form>
	);
};
